import api from "./axiosClient";
import { GetCalendarEventsResponse } from '../../proto/generated/calendar-event'

export const getCompanyEvents = (): Promise<GetCalendarEventsResponse> => {
    return new Promise((resolve, reject) => {
        const url = `/calendar-events`;
        const today = new Date().toLocaleDateString('en-GB').replace(/\//g, '');

        api.get<GetCalendarEventsResponse>(url, {
            headers: { Accept: 'application/json' },
            responseType: 'json'
        })
            .then(response => resolve(response.data))
            .catch(error => {
                console.error("Error fetching today's company events:", error);
                reject(error);
            });
    });
};



